import React, { Suspense } from "react";

import { settings } from "constants/settings";
import { CircularProgress } from "@material-ui/core";

function ProfileComponent(props) {
  const { children } = props;

  const Comp = React.lazy(() => import("./Profile." + settings.UI + ".js"));

  return (
    <Suspense fallback={<CircularProgress />}>
      <Comp>{children}</Comp>
    </Suspense>
  );
}

export default ProfileComponent;
